<template>
  <div class="cat-busqueda" :class="{ expandida: value.trim() }" @click="$refs.input.focus()">
    <AppIcon name="search" size="h-4 w-4" />
    <input
      ref="input"
      :value="value"
      type="search"
      :placeholder="placeholder"
      :aria-label="placeholder"
      :data-testid="testid"
      @input="alEscribir"
    />
  </div>
</template>

<script>
/*
 * AppBusqueda — buscador de los catálogos.
 *
 * Compacto en reposo, crece al enfocarlo (o mientras tiene texto). Emite
 * `input` al teclear (v-model) y `buscar` cuando se deja de escribir
 * (`espera` ms), para no pedirle al backend una consulta por tecla.
 */
import AppIcon from '@/components/ui/AppIcon.vue'

export default {
  name: 'AppBusqueda',
  components: { AppIcon },
  props: {
    value: { type: String, default: '' },
    placeholder: { type: String, default: 'Buscar' },
    testid: { type: String, default: 'busqueda' },
    espera: { type: Number, default: 350 },
  },
  watch: {
    // Si el padre cambia el texto (p. ej. "Limpiar filtros"), se cancela la búsqueda pendiente
    value(nuevo) {
      if (nuevo !== this.ultimoTecleado) clearTimeout(this.temporizador)
    },
  },
  beforeDestroy() {
    clearTimeout(this.temporizador)
  },
  methods: {
    alEscribir(event) {
      const texto = event.target.value
      this.ultimoTecleado = texto
      this.$emit('input', texto)
      clearTimeout(this.temporizador)
      this.temporizador = setTimeout(() => this.$emit('buscar', texto.trim()), this.espera)
    },
  },
}
</script>

<style scoped>
.cat-busqueda {
  display: flex;
  width: 170px;
  min-width: 170px;
  min-height: 42px;
  flex: 0 0 170px;
  align-items: center;
  overflow: hidden;
  gap: 8px;
  padding: 0 12px;
  border: 1px solid #e2e8ef;
  border-radius: 11px;
  background: #fff;
  box-shadow: 0 3px 12px rgba(16, 42, 67, 0.04);
  color: #607187;
  transition: width 0.22s ease, flex-basis 0.22s ease, border-color 0.16s ease, box-shadow 0.16s ease;
}
.cat-busqueda:focus-within,
.cat-busqueda.expandida {
  width: 320px;
  flex-basis: 320px;
}
.cat-busqueda:focus-within {
  border-color: #0a4f9c;
  box-shadow: 0 0 0 3px rgba(122, 185, 242, 0.55);
}
.cat-busqueda input {
  width: 100%;
  min-width: 0;
  flex: 1;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: #0b1b2e;
  font-family: inherit;
  font-size: 14px;
  outline: none;
}
@media (prefers-reduced-motion: reduce) {
  .cat-busqueda {
    transition: none;
  }
}
@media (max-width: 700px) {
  .cat-busqueda {
    width: 150px;
    min-width: 150px;
    flex-basis: 150px;
  }
  .cat-busqueda:focus-within,
  .cat-busqueda.expandida {
    width: calc(100% - 118px);
    flex-basis: calc(100% - 118px);
  }
}
</style>
